import { Link } from "react-router-dom";

/**
 * Compact disclaimer + link for pages with no full footer (auth screens).
 * Guarantees the "every page carries the disclaimer link" requirement.
 */
export default function DisclaimerNote() {
  return (
    <div className="mt-8 pt-5 border-t-2 border-ink/20 font-mono text-[10px] leading-relaxed text-muted-foreground"
         data-testid="disclaimer-note">
      Checkmate Payroll is a private software provider. We are not affiliated with, endorsed by, or
      representing any government entity.{" "}
      <Link to="/legal/disclaimer" data-testid="disclaimer-note-link" className="underline hover:text-ink">
        Full disclaimer
      </Link>
    </div>
  );
}
